import { render, staticRenderFns } from "./IssueReportForm.vue?vue&type=template&id=4312fcaf&scoped=true&"
import script from "./IssueReportForm.vue?vue&type=script&lang=js&"
export * from "./IssueReportForm.vue?vue&type=script&lang=js&"
import style0 from "./IssueReportForm.vue?vue&type=style&index=0&id=4312fcaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312fcaf",
  null
  
)

export default component.exports